export default [
  {
    path: '/cohort-analysis',
    name: 'PageCohortAnalysisList',
    meta: { title: 'cohortAnalysis.listTitle', roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'], permissions: ['cohort_analysis_view'] },
    component: () => import('@/pages/cohort-analysis'),
  },
  {
    path: '/cohort-analysis-cumulative',
    name: 'PageCohortAnalysisCumulativeList',
    meta: { title: 'cohortAnalysisCumulative.listTitle', roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'], permissions: ['cohort_analysis_cumulative_view'] },
    component: () => import('@/pages/cohort-analysis-cumulative'),
  },
]